<template>
    <div class="grid">
        <div class="col-12">
            <div class="card" v-if="permission?.includes('read')">
                <Toast />
                <Error :errors="errors" />

                <Fieldset legend="Filter" :toggleable="true" :collapsed="true" class="mb-3">
                    <Filter @submit="getDataTable()" ref="filter" />
                </Fieldset>

                <Fieldset legend="Import" :toggleable="true" :collapsed="true" class="mb-3"
                    v-if="permission.includes('create')">
                    <Import @submit="getDataTable()" ref="import" />
                </Fieldset>

                <Fieldset legend="Update Status" :toggleable="true" :collapsed="true" class="mb-3"
                    v-if="permission.includes('create')">
                    <UpdateStatus @submit="getDataTable()" ref="update-status" />
                </Fieldset>

                <DataTable :value="dataTable" responsiveLayout="scroll" :loading="loading" dataKey="number"
                    @sort="onSort($event)" :resizableColumns="true">
                    <template #header>
                        <div class="flex flex-column md:flex-row md:justify-content-between md:align-items-center">
                            <div>
                                <Button :loading="loadingExcel" label="Export Excel" icon="pi pi-file-excel"
                                    class="p-button p-button-success mr-2 my-1 inline-block"
                                    @click="exportExcelCSV('xlsx')" />
                                <Button :loading="loadingCsv" label="Export CSV" icon="pi pi-file-excel"
                                    class="p-button p-button-success mr-2 my-1 inline-block"
                                    @click="exportExcelCSV('csv')" />
                            </div>
                            <span class="block mt-2 md:mt-0 p-input-icon-left">
                                <i class="pi pi-search" />
                                <InputText v-model="search" placeholder="Cari..." @keyup.enter="getDataTable" />
                            </span>
                        </div>
                    </template>
                    <Column field="number" header="No." :style="{ width: '20px' }">
                        <template #body="slotProps">
                            {{ slotProps.data.number }}
                        </template>
                    </Column>
                    <Column field="region_name" header="Region">
                        <template #body="slotProps">
                            {{ slotProps.data.region_name }}
                        </template>
                    </Column>
                    <Column field="ship_to_code" header="Ship To Code">
                        <template #body="slotProps">
                            {{ slotProps.data.ship_to_code }}
                        </template>
                    </Column>
                    <Column field="distributor_name" header="Distributor">
                        <template #body="slotProps">
                            {{ slotProps.data.distributor_name }}
                        </template>
                    </Column>
                    <Column field="outlet_code" header="Outlet Code">
                        <template #body="slotProps">
                            {{ slotProps.data.outlet_code }}
                        </template>
                    </Column>
                    <Column field="outlet_name" header="Outlet Name">
                        <template #body="slotProps">
                            {{ slotProps.data.outlet_name }}
                        </template>
                    </Column>
                    <Column field="outlet_alamat" header="Outlet Address">
                        <template #body="slotProps">
                            {{ slotProps.data.outlet_alamat }}
                        </template>
                    </Column>
                    <Column field="outlet_latitude" header="Latitude">
                        <template #body="slotProps">
                            {{ slotProps.data.outlet_latitude }}
                        </template>
                    </Column>
                    <Column field="outlet_longitude" header="Longitude">
                        <template #body="slotProps">
                            {{ slotProps.data.outlet_longitude }}
                        </template>
                    </Column>
                    <Column field="is_outlet_active" header="Status">
                        <template #body="slotProps">
                            <Button icon="pi pi-check" class="p-button-rounded p-button-success"
                                v-if="slotProps.data.is_outlet_active == 'y'" />
                            <Button icon="pi pi-times" class="p-button-rounded p-button-danger" v-else />
                        </template>
                    </Column>

                    <Column header="Aksi" field="aksi">
                        <template #body="slotProps">
                            <Button v-if="permission.includes('update')" @click="editItem(slotProps.data)"
                                icon="pi pi-pencil" class="p-button-rounded p-button-success mr-2" />
                            <Button icon="pi pi-refresh" class="p-button-rounded p-button-danger mr-2"
                                @click="resetItem(slotProps.data)" v-if="permission.includes('update')" />
                        </template>
                    </Column>


                    <template #empty> No data found. </template>
                    <template #loading> Loading data. Please wait. </template>
                    <template #footer>
                        In total there are {{ totalItemsCount ? totalItemsCount : 0 }} data.
                    </template>
                </DataTable>

                <Paginator v-model:rows="rows" v-model:first="offset" :totalRecords="totalItemsCount"
                    :rowsPerPageOptions="[10, 20, 30]">
                    <template>
                        {{ totalItemsCount }}
                    </template>
                </Paginator>

                <Reset @submit="getDataTable()" :item="item" ref="reset"/>

                <Dialog v-model:visible="editItemDialog" :style="{ width: '450px' }" header="Edit Target" :modal="true"
                    class="p-fluid">
                    <div class="field">
                        <label>Distributor</label>
                        <Dropdown id="distributor_id" ref="ddistributor" dataKey="distributor_id"
                            v-model="item.distributor_id" :loading="loadingDropdownDistributor"
                            :options="dataDropdownDistributor" optionLabel="label" optionValue="distributor_id"
                            placeholder="Pilih Distributor" :filter="true" :showClear="true"
                            @filter="searchDropdownDistributor($event, 'edit')" />
                    </div>

                    <div class="field">
                        <label>Outlet Code</label>
                        <InputText v-model="item.outlet_code" required="true" autofocus
                            :class="{ 'p-invalid': errorAdd.outlet_code }" />
                        <small class="p-invalid" style="color: red" v-if="errorEdit.outlet_code">{{
                            errorEdit.outlet_code[0]
                        }}</small>
                    </div>

                    <div class="field">
                        <label>Outlet Name</label>
                        <InputText v-model="item.outlet_name" required="true" autofocus
                            :class="{ 'p-invalid': errorAdd.outlet_name }" />
                        <small class="p-invalid" style="color: red" v-if="errorEdit.outlet_name">{{
                            errorEdit.outlet_name[0]
                        }}</small>
                    </div>


                    <div class="field">
                        <label>Outlet Address</label>
                        <InputText v-model="item.outlet_address" required="true" autofocus
                            :class="{ 'p-invalid': errorAdd.outlet_address }" />
                        <small class="p-invalid" style="color: red" v-if="errorEdit.outlet_address">{{
                            errorEdit.outlet_address[0]
                        }}</small>
                    </div>


                    <div class="field">
                        <label>Outlet Latitude</label>
                        <InputText v-model="item.outlet_latitude" required="true" autofocus
                            :class="{ 'p-invalid': errorAdd.outlet_latitude }" />
                        <small class="p-invalid" style="color: red" v-if="errorEdit.outlet_latitude">{{
                            errorEdit.outlet_latitude[0]
                        }}</small>
                    </div>

                    <div class="field">
                        <label>Outlet Longitude</label>
                        <InputText v-model="item.outlet_longitude" required="true" autofocus
                            :class="{ 'p-invalid': errorAdd.outlet_longitude }" />
                        <small class="p-invalid" style="color: red" v-if="errorEdit.outlet_longitude">{{
                            errorEdit.outlet_longitude[0]
                        }}</small>
                    </div>


                    <template #footer>
                        <Button label="Batal" icon="pi pi-times" class="p-button-text" @click="hideDialog" />
                        <Button label="Simpan" icon="pi pi-check" class="p-button-text" @click="update"
                            :loading="loadingEditItem" />
                    </template>
                </Dialog>

            </div>
        </div>
    </div>
</template>

<script>
import moment from "moment";
import { mapGetters } from "vuex";
import { numberingDatatable } from "../../utils/helpers";
import Error from "../../components/Error.vue";
import Import from "../../components/master/outlet/Import.vue";
import Filter from "../../components/master/outlet/Filter.vue";
import Reset from "../../components/master/outlet/Reset.vue";
import UpdateStatus from "../../components/master/outlet/UpdateStatus.vue";

export default {
    components: {
        Error: Error,
        Import: Import,
        Filter: Filter,
        Reset: Reset,
        UpdateStatus: UpdateStatus,
    },
    data() {
        return {
            // loading
            loading: false,
            loadingExcel: false,
            loadingCsv: false,
            loadingEditItem: false,
            loadingDropdownDistributor: false,

            //datatables
            data: null,
            dataTable: null,
            rows: 10,
            search: null,
            offset: null,
            field: null,
            sort: null,
            page: null,
            totalItemsCount: 0,

            // edit
            editItemDialog: false,
            item: {},

            // dropdown
            dataDropdownDistributor: null
        };
    },
    mounted() {
        this.getDataTable();
        this.$store.commit("setErrors", {});
    },
    watch: {
        offset() {
            this.getDataTable();
        },
        rows() {
            this.getDataTable();
        },
    },
    computed: {
        ...mapGetters(['errors', 'errorEdit', 'errorAdd']),
        ...mapGetters("auth", ["permission"]),
    },
    methods: {
        formatDate(value) {
            if (value) {
                return moment.utc(value).format("DD-MM-YYYY");
            }
        },
        // DATATABLE
        getDataTable() {
            this.loading = true;

            if (this.$refs?.filter) {
                this.$refs.filter.loading = true;
            }

            this.page = this.offset / this.rows + 1;

            this.axios({
                method: "GET",
                url: process.env.VUE_APP_ROOT_API + "web/master-outlet",
                params: {
                    search: this.search,
                    per_page: this.rows,
                    page: this.page,
                    order_by: this.field,
                    sort_by: this.sort,
                    region_id: this.$refs?.filter?.filters.region_id,
                    distributor_id: this.$refs?.filter?.filters.distributor_id
                },
            })
                .then((res) => {
                    this.data = res.data.data.data;
                    this.dataTable = numberingDatatable(
                        res.data.data.data,
                        this.page,
                        this.rows
                    );
                    this.totalItemsCount = res.data.data.total;
                    this.rows = parseInt(res.data.data.per_page);
                    this.loading = false;
                    this.$refs.filter.loading = false;
                })
                .catch((err) => {
                    console.log(err);
                    this.loading = false;
                    this.$refs.filter.loading = false;

                });
        },
        onSort(event) {
            this.field = event.sortField;
            this.sort = event.sortOrder == "1" ? "ASC" : "DESC";
            this.getDataTable();
        },
        // EXPORT
        exportExcelCSV(ext) {
            if (ext == "xlsx") {
                this.loadingExcel = true;
            } else if (ext == "csv") {
                this.loadingCsv = true;
            }

            this.axios({
                method: "GET",
                url: process.env.VUE_APP_ROOT_API + "web/master-outlet/export",
                responseType: "blob",
                params: {
                    ext: ext,
                    region_id: this.$refs?.filter?.filters.region_id,
                    distributor_id: this.$refs?.filter?.filters.distributor_id
                },
            })
                .then((response) => {
                    let fileUrl = window.URL.createObjectURL(response.data);
                    let fileLink = document.createElement("a");

                    fileLink.href = fileUrl;

                    fileLink.setAttribute("download", "Master Outlet Export." + ext);

                    document.body.appendChild(fileLink);

                    fileLink.click();

                    if (ext == "xlsx") {
                        this.loadingExcel = false;
                    } else if (ext == "csv") {
                        this.loadingCsv = false;
                    }
                })
                .catch((err) => {
                    console.log(err);

                    if (ext == "xlsx") {
                        this.loadingExcel = false;
                    } else if (ext == "csv") {
                        this.loadingCsv = false;
                    }
                });
        },

        // DROPDOWN
        searchDropdownDistributor(event, purpose, valueEdit) {
            setTimeout(() => {
                if (valueEdit) {
                    this.$refs.ddistributor.filterValue = valueEdit;
                }

                if (purpose == "edit") {
                    this.loadingDropdownDistributor = true;
                }

                this.axios({
                    method: "GET",
                    url: process.env.VUE_APP_ROOT_API + "web/select2/distributor-outlet",
                    params: {
                        search: valueEdit ? valueEdit : event.value,
                    },
                })
                    .then((res) => {
                        if (purpose == "edit") {
                            this.dataDropdownDistributor = res.data.data;
                            this.loadingDropdownDistributor = false;
                        } else if (purpose == null) {
                            this.dataDropdownDistributor = res.data.data;
                        }
                    })
                    .catch((err) => {
                        console.log(err);
                    });
            }, 250);
        },
        // RESET
        resetItem(item) {
            this.item = item;

            this.$refs.reset.resetItemDialog = true;
        },

        // EDIT
        editItem(item) {
            this.item = item;
            this.item.outlet_address = item.outlet_alamat;
            this.searchDropdownDistributor('', 'edit', this.item.distributor_name);
            this.editItemDialog = true;
            this.$store.commit('setErrorEdit', {});

        },
        hideDialog() {
            this.editItemDialog = false;
            this.submitted = false;
        },
        update() {
            this.loadingEditItem = true;

            this.axios({
                method: 'POST',
                url: process.env.VUE_APP_ROOT_API + 'web/master-outlet/update',
                data: {
                    ...this.item
                },
            })
                .then((res) => {
                    this.loadingEditItem = false;
                    if (res) {
                        this.$toast.add({ severity: 'success', summary: 'Successful', detail: 'Data Berhasil Diupdate', life: 3000, });
                        this.$store.commit('setErrors', {});
                        this.$store.commit('setErrorEdit', {});
                        this.item = {};
                        this.editItemDialog = false;
                        this.getDataTable();
                    }
                })
                .catch((err) => {
                    console.log(err);
                    this.loadingEditItem = false;
                    this.$store.commit('setErrorEdit', err.response.data.data);
                    this.$toast.add({ severity: 'error', summary: 'Failed', detail: 'Data Gagal Diperbarui', life: 3000, });
                });
        },
    },
};
</script>
